





























import { Notification as NotificationModel } from "@/models/notification";
import { pause } from "@/lib/helpers";
import {
  computed,
  defineComponent,
  onBeforeUnmount,
  onMounted,
  PropType,
  ref
} from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";
import { useRouter } from "@/hooks/use-router";

export default defineComponent({
  props: {
    notification: {
      type: Object as PropType<NotificationModel>,
      required: true
    },
    elevation: {
      type: [Number, String],
      default: 0
    },
    show: {
      default: true
    }
  },
  setup(props) {
    const { store } = useVuex();
    const router = useRouter();
    const expert = computed(() => store.state.Settings.mode === "expert");
    const className = ref("");
    let timer: any;

    const isLight = computed(() => props.notification?.type === "info");

    onMounted(() => {
      timer = setTimeout(() => {
        className.value = "animate--in";
      }, 25);
    });

    onBeforeUnmount(() => {
      clearTimeout(timer);
      className.value = "";
    });

    const open = async () => {
      if (!props.notification) return;
      store.dispatch.Loading.startLoading({
        command: "startLoadingOverlay",
        value: "Loading…"
      });
      await pause(50);
      await router.push("/force-rerender");
      router
        .push({ path: "/notification/" + props.notification.id })
        .then(() => {
          store.commit.Loading.stopLoading();
          store.commit.Notifications.dismiss(
            (props.notification as NotificationModel).id
          );
        });
    };

    return {
      expert,
      isLight,
      className,
      open
    };
  }
});
